import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { main, light } = theme.palette.primary;
  return {
    allCoursesList: {
      width: "100%",
      "&.popupView": {
        height: "calc(100% - 48px)",
        overflowY: "auto",
        borderRadius: 4,
        "& $allCoursesListItem": {
          padding: "14px 20px"
        }
      }
    },
    allCoursesListItem: {
      padding: "20px 30px",
      borderBottom: "1px solid #eeeeee",
      "&:nth-child(even)": {
        backgroundColor: "#fbfbfb"
      }
    },
    listItemHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    listItemHeaderTitle: {
      display: "flex",
      alignItems: "center",
      lineHeight: 1
    },
    marker: {
      display: "flex",
      marginRight: 6
    },
    facilityName: {
      fontSize: 16,
      color: main,
      marginRight: 10
    },
    listItemHeaderLastChanged: {
      fontSize: 14,
      color: main,
      whiteSpace: "nowrap"
    },
    listItemBody: {},
    courseInfoContainer: {
      marginTop: 10
    },
    courseInfo: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    courseCondition: {},
    courseName: {
      fontSize: 14,
      color: "#1a1a1a",
      marginRight: 4
    },
    conditionTitle: {
      fontSize: 14,
      color: "#1a1a1a",
      fontWeight: 600
    },
    lastUpdated: {
      fontSize: 14,
      fontWeight: 600,
      color: "#1a1a1a"
    },
    courseComment: {
      marginTop: 6,
      color: "#595a5a",
      fontSize: 12
    },
    noDataHolder: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      width: "100%"
    },
    noDataHolderText: {
      marginTop: 50,
      fontSize: "20px",
      color: light
    },
    loader: {
      marginTop: "50%"
    }
  };
});
